import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const DocumentListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: calc(100vh - 205px);
  overflow-y: auto;
`;

export interface DocumentListSectionStyledProps {
  canUploadDocument: boolean;
}

export const DocumentListSectionStyled = styled(Box).attrs({
  flexGrow: { sm: '1' },
  mb: { sm: '300' },
  flexDirection: { sm: 'column' },
})<DocumentListSectionStyledProps>`
  overflow-y: auto;
  ${({ canUploadDocument }) =>
    canUploadDocument &&
    css`
      box-shadow:
        0 2px 4px -1px rgba(0, 0, 0, 0.2),
        0 1px 10px 0 rgba(0, 0, 0, 0.12),
        0 4px 5px 0 rgba(0, 0, 0, 0.14);
    `}
`;

interface DocumentLinkStyledProps {
  isSelected: boolean;
}

export const DocumentLinkStyled = styled.div<DocumentLinkStyledProps>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  display: block;
  padding: ${({ theme }) => theme.spacings[500]};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue[100]};
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${({ theme }) => theme.colors.blue[100]};
    `}
`;
